module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/CentralJuvie-6_BW-p-130x130q80-cc489c619f00eead0a04f5fe3c7c0254.jpg";